module.exports = __webpack_public_path__ + "img/active_5.17b62c57.png";